import { Component, EventEmitter, OnInit } from '@angular/core';
import { ApiService } from 'src/app/pages/common/api.service';
import { debounceTime } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss']
})
export class SearchComponent implements OnInit {
  private subject: Subject<string> = new Subject();

  // output vars
  searchItemEvent: EventEmitter<any> = new EventEmitter();
  hideEvent: EventEmitter<boolean> = new EventEmitter();
  selectedItemEvent: EventEmitter<any> = new EventEmitter();

  searching = false;
  itemList: Array<any>;

  searchInput = '';

  constructor(
    public _apiService: ApiService
  ) { }

  ngOnInit(): void {
    setTimeout(()=>{
      document.getElementById("search-input").focus();
    }, 500);
    this.subject.pipe(
      debounceTime(500)
    ).subscribe(inp => {
      this.searchItem(inp);
    });
  }
  debouncedMerchantSearch(inp: any) {
    this.subject.next(inp);
  }
  hideModal() {
    this.hideEvent.emit(true);
  }


  searchItem(name) {
    if (this.searchInput.length > 2) {
      this.searching = true;
      this.itemList = [];
      const params = { name: this.searchInput };
      this._apiService.searchMerchants(params).subscribe(
        (res: any) => {
          if (res && res.data) {
            this.itemList = res.data.slice(0, 7);
          }
          this.searching = false;
        },
        (err) => {
          this.searching = false;
        }
      );
    }
    else{
      this.searching = false;
      this.itemList = [];
    }
  }

  onItemClick(item) {
    this.selectedItemEvent.emit({
      item
    })
  }


}
